import React, { useRef } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

//style rules
import { Typography, Colors, Sizes } from "../styles";

const SiteSearch404 = () => {
	const inputRef = useRef(null);

	const renderSubmit = (e) => {
		e.preventDefault();
		const searchInput = inputRef.current.value;
		if (!searchInput) return;
		const searchUrl = `/?s=${searchInput}`;

		// navigate to the new URL
		window.location.href = searchUrl;

		// clear the search bar
		inputRef.current.value = "";
	};

	return (
		<SearchContainer>
			<FormText>Try another search</FormText>
			<Form role="search" action="/" method="get" onSubmit={renderSubmit}>
				<InputContainer>
					<InputLabel>Enter your search</InputLabel>
					<Input
						ref={inputRef}
						type={"text"}
						name="s"
						placeholder="Search"
						id="search-input"
					/>
					<Icon
						role="button"
						aria-label="Open search input"
						className="icon-toggle exclude-button-styles"
						tabIndex={0}
					>
						<img
							src={`${mainScript.assetPath}images/svg/icons/icon-search-dark.svg`}
							alt=""
							width="20px"
							height="20px"
						/>
					</Icon>
				</InputContainer>
			</Form>
		</SearchContainer>
	);
};

export default SiteSearch404;

const SearchContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
`;

const Icon = styled.button`
	width: 2rem;
	height: 2rem;
	cursor: pointer;
	position: absolute;
	right: 2.69rem;
	border: none;
	background: none;
	padding: 0;

	img {
		width: 2rem;
		height: 2rem;
	}

	&::after {
		display: none;
		transition: unset;
	}

	&:hover,
	&:focus {
		transition: unset;
		padding-right: 0;
	}
`;

const Form = styled(motion.form)`
	position: relative;
	z-index: 11;
	align-items: baseline;

	width: 100%;
	border: 48.5rem;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		width: 48.5rem;
		max-width: 65rem;
	}
`;

const FormText = styled.p`
	font-weight: ${Typography.fontWeight.bold};
`;

const InputContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	position: relative;
`;

const Input = styled.input`
	height: 61px !important;
	padding: 0.8rem 2rem !important;
	border-radius: 3rem !important;
	margin-bottom: 0 !important;
	border: 2px solid ${Colors.fp.pineGreen};
	width: 100%;

	&::placeholder {
		font-size: 1.6rem;
		line-height: 2.7rem;
		font-weight: ${Typography.fontWeight.medium};
	}

	&:focus {
		border: 1px solid red; /* Change the border color to blue when focused */
	}
`;

const InputLabel = styled.label`
	position: absolute;
	top: -22px;
	visibility: hidden;
`;

SiteSearch404.propTypes = {
	location: PropTypes.string,
};
